export const config = {
  graphqlUrl: process.env.REACT_APP_GRAPHQL_URL || "",
  whatsappApiUrl: process.env.REACT_APP_WHATSAPP_API_URL || "",
  whatsappApiToken: process.env.REACT_APP_WHATSAPP_API_TOKEN || "",
  graphqlApiKey: process.env.REACT_APP_GRAPHQL_API_KEY || "",
  webPushPublicKey: process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY || "",
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || "",
  sentryEnvironment:
    process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development",
  sentryRelease: process.env.REACT_APP_SENTRY_RELEASE || undefined,
  sentryEnabled:
    process.env.REACT_APP_SENTRY_ENABLED === "true" || process.env.NODE_ENV === "production",
  sentryTracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
};
